/**
 * Copyright (c) 2026-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const ThumbFilled = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M2 9h3v12H2a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1m5.3-1.3 6.4-6.4a.5.5 0 0 1 .65-.04l.85.64c.48.36.7.98.55 1.57L14.6 8H21a2 2 0 0 1 2 2v2.1a2 2 0 0 1-.15.77l-3.1 7.51a1 1 0 0 1-.92.62H8a1 1 0 0 1-1-1V8.41a1 1 0 0 1 .3-.7" />
  </Icon>
);
